export default {
  metadating: {
    MetadatingError: true,
    MalformedMetadata: false,
    CorruptedOrUnsupportedFile: true,
    InvalidFileFormat: true,
    DownloadError: true,
  },
  replicating: {
    ReplicatingError: true,
    MalformedMetadata: false,
    CorruptedOrUnsupportedFile: true,
    InvalidFileFormat: true,
    DownloadError: true,
    UploadError: true,
    UploadPermissionsError: true,
    UploadQuotaError: true,
  },
  thumbnailing: {
    ThumbnailingError: true,
    MalformedMetadata: false,
    CorruptedOrUnsupportedFile: true,
    InvalidFileFormat: true,
    DownloadError: true,
  },
  converting: {
    ConvertingError: true,
    MalformedMetadata: false,
    CorruptedOrUnsupportedFile: true,
    InvalidFileFormat: true,
    DownloadError: true,
  },
  crawling: {
    UnreachableUrlError: true,
    CrawlingError: true,
  },
};
